import { render } from "./InputTextBoxElement.vue?vue&type=template&id=049024fa&scoped=true"
import script from "./InputTextBoxElement.vue?vue&type=script&lang=js"
export * from "./InputTextBoxElement.vue?vue&type=script&lang=js"

import "./InputTextBoxElement.vue?vue&type=style&index=0&id=049024fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049024fa"]])

export default __exports__